export default __webpack_public_path__ + "static/media/weblogoBlueNew.2cca5fe8.svg";